import React, {Component} from "react";
import './Hangman.css';
import img0 from './0.jpg';
import img1 from './1.jpg';
import img2 from './2.jpg';
import img3 from './3.jpg';
import img4 from './4.jpg';
import img5 from './5.jpg';
import img6 from './6.jpg';
import {randomWord} from './words.js';
import {CopyToClipboard} from "react-copy-to-clipboard";

class Hangman extends Component {
    static defaultProps = {
        images: [img0, img1, img2, img3, img4,img5, img6]
    };
    constructor (props){
        super(props);
        this.state = {nWrong:0, guessed: new Set(), answer: randomWord(), shared:"" };
        this.handleClick = this.handleClick.bind(this);
        this.resetGame = this.resetGame.bind(this);
        this.handleCopy=this.handleCopy.bind(this);
        }
    guessedWord(){
        
        return this.state.answer
        .split("")
        .map(ltr=>(this.state.guessed.has(ltr)?ltr : " _ "));
    }
    shareWord(){
        return this.state.answer
        .split("")
        .map(ltr=>(this.state.guessed.has(ltr)?'✅ ' : "⬛ "));
    }
     handleClick(ltr){
        let value = ltr.target.value;
        let count = this.state.nWrong + (this.state.answer.includes(value)? 0: 1);
        
        this.setState ({guessed: this.state.guessed.add(value), nWrong:count});
let currentWord = `${ this.shareWord().join("")}`
console.log(currentWord);
this.setState ({shared:this.state.shared+`
${currentWord}`});
console.log(this.state.shared);
    }
    answerList(){
        return "abcdefghijklmnopqrstuvwxyz".split("")
        .map(ltr=> <button key = {ltr} className="Hangman-button" value={ltr} onClick={this.handleClick} disabled={this.state.guessed.has(ltr)}>{ltr}</button>);
    }
    resetGame(){
        this.setState ({nWrong:0, guessed: new Set(), answer: randomWord(), shared:""});
    }
    handleCopy(word){
        return alert(`https://projecthangman.netlify.app/
${this.state.shared}
#hangman
Copied`)
    }
    render(){
        const gameState = this.guessedWord().join("")===this.state.answer;
        const word = `https://projecthangman.netlify.app/ 
${this.state.shared}
#hangman`;
         if (gameState) {
            return(
            <div className="Hangman">
                <h1>Hangman</h1>
                <img alt = "You Win"className = "Hangman-image"src={this.props.images[this.state.nWrong]}/>
                <p className="Hangman-word">{this.guessedWord()}</p>
                <h2>You Won!</h2>
                <p>Correct Answer: {this.state.answer}</p>
                <button className="Hangman-reset" onClick={this.resetGame}>New Game</button>
                <CopyToClipboard text={word} ><button className="Hangman-reset" onClick={this.handleCopy}>Copy To Clipboard</button></CopyToClipboard>
                </div>
                );
        }if (this.state.nWrong===6){
            return(
                <div className="Hangman">
                <h1>Hangman</h1>
                <img alt= "GameOver"className = "Hangman-image"src={this.props.images[this.state.nWrong]}/>
                <p className="Hangman-word">{this.guessedWord()}</p>
                <h2>Game Over!</h2>
                <p>Correct Answer: {this.state.answer}</p>
                <button className="Hangman-reset" onClick={this.resetGame}>New Game</button>
                <CopyToClipboard text={word} ><button className="Hangman-reset" onClick={this.handleCopy}>Copy To Clipboard</button></CopyToClipboard>
                </div>)
        }
        else {
        return(
            <div className="Hangman">
            <h1>Hangman</h1>
            <img alt={this.props.images[this.state.nWrong]} className = "Hangman-image"src={this.props.images[this.state.nWrong]}/>
            <p className="Hangman-word">{this.guessedWord()}</p>
            <p>Number of incorrect chances left: {6-this.state.nWrong}</p>
            <p className="Hangman-letters">{this.answerList()}</p>
            <button className="Hangman-reset" onClick={this.resetGame}>New Game</button>
            </div>
        );}

        };
    }



export default Hangman;